import React, { Component } from "react";
import { connect } from "react-redux";
import HireButton from "../../Common/Hire";
import SendEmail from "../../Common/SendEmail";
import QuotationPrice from "../../Common/Quotation/Price";
import QuotationTitle from "../../Common/Quotation/Title";
import { Text } from "../../Common/Form";
import Loader from '../../Common/Loader';
import ErrorMessage from '../../Common/ErrorMessage';
import { yates, client } from "../../../operations";
import { 
  setInnerPagesList,
  setStepInnerPage 
} from '../../../actions';

import conditions from "../../../resources/Condiciones-Generales-Cobertura-Yacht-Standard.pdf";

class Quotation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: true,
    };

    this.priceContent = this.priceContent.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'quotation', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  priceContent() {
    return(
      <div className="Price-content">
        <div className="Price-content_1"> COTIZACIÓN COBERTURA STANDARD </div>
        {/* 
        <div className="Price-content_2">
          El seguro entratrá en vigencia 3 días después de efectuada la compra.
        </div> 
        */}
        <div className="Price-content_2">
          <div> Carencia temporal: la vigencia de la póliza comenzará </div>
          <div> 72 horas después de la fecha de emisión. </div>
        </div>
        <div className="Price-content_3">
          <a download="Condiciones Generales" href={conditions}> Condiciones Generales </a>
        </div>
      </div>
    );
  }

  render() {

    const { 
      stepInnerPage, loading, 
      quoteId, sendQuoteByEmail, 
      quoter, errorMessage,
      setStepInnerPage, getQuotation
    } = this.props;

    switch (stepInnerPage.name) {
      case 'quotation':
        return (<div>
                  { loading ? 
                      <Loader /> :
                      quoteId > 0 ?
                        <div style={{'paddingTop': '10px'}}>
                          <QuotationTitle />
                          <QuotationPrice priceContent={this.priceContent} />
                          <HireButton onThinkClick={() => {
                            setStepInnerPage('sendEmail');
                            sendQuoteByEmail(quoter);
                          }}/>
                        </div> : errorMessage ?
                        <ErrorMessage 
                          errorText='Tuvimos un inconveniente con la cotización'
                          tryAgainText= 'Volver a cotizar'
                          tryAgainAction={getQuotation}
                        /> : null
                  }
                </div>);
      case 'sendEmail':
        return <SendEmail />;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    quoteId: state.quotation.quoteId,
    errorMessage: state.quotation.errorMessage,
    stepInnerPage: state.steps.stepInnerPage,
    quoter: state.options.quoter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    getQuotation: () => {
      dispatch(yates.getQuotation());
    },
    sendQuoteByEmail: (quoter) => {
      dispatch(client.sendQuoteByEmail(quoter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);